// https://stackoverflow.com/questions/43108155/angular-2-how-to-keep-event-from-triggering-digest-loop-detection-cycle

import { Injectable, NgZone, inject } from '@angular/core';
import { EVENT_MANAGER_PLUGINS, EventManager } from '@angular/platform-browser';

@Injectable()
export class CustomEventManager extends EventManager {
  private zone: NgZone;

  constructor() {
    const plugins = inject(EVENT_MANAGER_PLUGINS);
    const zone = inject(NgZone);

    super(plugins, zone);

    this.zone = zone;
  }

  addEventListener(element: HTMLElement, eventName: string, handler: Function): Function {
    if (eventName.endsWith('out-zone')) {
      eventName = eventName.split('.')[0];
      return this.zone.runOutsideAngular(() =>
        super.addEventListener(element, eventName, handler));
    }

    return super.addEventListener(element, eventName, handler);
  }
}
